import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Network, Search, X } from "lucide-react";
import { AppDispatch, RootState } from "../../../../../store";
import { getReferralNetwork } from "../../../../../Redux/referral/slice";
import Pagenation from "../../../../../ecommerce/globalcomponents/pagenation/Pagenation";
import ReffCommTeamTable from "./ReffCommTeamTable";
import CombinedLevelsTable from "./CombinedLevelsTable";
import "../SalarFlowPage.css";

const ReferralCommissoinTeam = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNo = queryParams.get("orderNo") || "";

  const { referralNetwork } = useSelector(
    (state: RootState) => state.referral,
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (orderNo) {
      dispatch(
        getReferralNetwork({
          orderNo,
          page,
          limit,
          status: "ALL",
          sortOrder: "DESC",
          search: debouncedSearch || undefined,
        }),
      );
    }
  }, [dispatch, orderNo, page, limit, debouncedSearch]);

  const networkData = referralNetwork.data;
  const orderDetails = networkData?.orderDetails;
  const milestones = networkData?.network?.milestones || [];
  const combinedLevels = networkData?.combinedLevels || [];
  const summary = networkData?.network?.summary;

  return (
    <section className="ri-page">
      <div className="ri-shell">
        <header className="ri-page-header">
          <div className="ri-page-title">
            <span className="ri-title-icon">
              <Network size={25} />
            </span>
            <div>
              <span className="ri-eyebrow">SALAR FLOW NETWORK</span>
              <h1>
                Salar Flow Network :{" "}
                {orderDetails?.orderNo || orderNo || "—"}
              </h1>
              <p>
                Review contribution requirement, active contributors and
                milestone status for this order.
              </p>
            </div>
          </div>
          {summary && (
            <span className="ri-count-pill">
              {summary.completedMilestones ?? 0}/{summary.totalMilestones ?? milestones.length} milestones
            </span>
          )}
        </header>

        <div className="ri-toolbar">
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            aria-label="Entries per page"
          >
            {[10, 25, 50, 75, 100].map((val) => (
              <option value={val} key={val}>
                {val} Entries
              </option>
            ))}
          </select>

          <div className="ri-search">
            <Search size={19} />
            <input
              type="search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search network..."
              aria-label="Search network"
            />
            {search && (
              <button
                type="button"
                onClick={() => setSearch("")}
                aria-label="Clear search"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </div>

        <ReffCommTeamTable
          milestones={milestones}
          orderNo={orderNo}
          orderDetails={orderDetails}
        />

        {networkData?.showCombinedLevels && combinedLevels.length > 0 && (
          <CombinedLevelsTable levels={combinedLevels} orderNo={orderNo} />
        )}

        <Pagenation
          currentPage={page}
          totalPages={networkData?.pagination?.totalPages || 0}
          onPageChange={setPage}
        />
      </div>
    </section>
  );
};

export default ReferralCommissoinTeam;
